<template>
  <div class="loading-container">
    <div class="loading-content">
      <div class="loading-spinner-large">
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
      </div>
      <h5 class="loading-title">{{ title || 'Loading Data...' }}</h5>
      <p class="loading-text">{{ message || 'Please wait while we process your request' }}</p>
      <div v-if="showProgress" class="loading-progress">
        <div class="progress-bar">
          <div class="progress-fill"></div>
        </div>
        <span class="progress-text">{{ progressText || 'Processing...' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdvancedLoadingIndicator',
  props: {
    title: {
      type: String,
      default: 'Loading Data...'
    },
    message: {
      type: String,
      default: 'Please wait while we process your request'
    },
    showProgress: {
      type: Boolean,
      default: true
    },
    progressText: {
      type: String,
      default: 'Processing...'
    }
  }
};
</script>

<style scoped>
.loading-container {
  background: var(--card-bg);
  border: 2px solid var(--border-color);
  border-radius: 16px;
  padding: 3rem 2rem;
  margin: 2rem 0;
  text-align: center;
  box-shadow: 0 8px 24px var(--shadow-color);
}

.loading-content {
  max-width: 400px;
  margin: 0 auto;
}

.loading-spinner-large {
  position: relative;
  width: 100px;
  height: 100px;
  margin: 0 auto 2rem auto;
}

.spinner-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 4px solid transparent;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  animation: spin 1.5s linear infinite;
}

.spinner-ring:nth-child(2) {
  width: 70px;
  height: 70px;
  top: 15px;
  left: 15px;
  border-top-color: #28a745;
  animation-delay: -0.5s;
}

.spinner-ring:nth-child(3) {
  width: 45px;
  height: 45px;
  top: 27.5px;
  left: 27.5px;
  border-top-color: #ffc107;
  animation-delay: -1s;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-title {
  color: var(--text-primary);
  font-size: 1.75rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
}

.loading-text {
  color: var(--text-secondary);
  font-size: 1.1rem;
  margin: 0 0 1.5rem 0;
  line-height: 1.4;
}

.loading-progress {
  margin-top: 1.5rem;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background-color: var(--bg-tertiary);
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 0.5rem;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #007bff, #28a745, #ffc107);
  background-size: 200% 100%;
  animation: progressMove 2s ease-in-out infinite;
  border-radius: 4px;
}

@keyframes progressMove {
  0% {
    background-position: 0% 50%;
    width: 0%;
  }
  50% {
    background-position: 100% 50%;
    width: 70%;
  }
  100% {
    background-position: 0% 50%;
    width: 100%;
  }
}

.progress-text {
  color: var(--text-secondary);
  font-size: 0.9rem;
  font-style: italic;
}

@media (max-width: 750px) {
  .loading-container {
    padding: 2rem 1rem;
    margin: 1rem 0;
  }
  
  .loading-spinner-large {
    width: 80px;
    height: 80px;
  }
  
  .spinner-ring:nth-child(2) {
    width: 55px;
    height: 55px;
    top: 12.5px;
    left: 12.5px;
  }
  
  .spinner-ring:nth-child(3) {
    width: 35px;
    height: 35px;
    top: 22.5px;
    left: 22.5px;
  }
  
  .loading-title {
    font-size: 1.5rem;
  }
  
  .loading-text {
    font-size: 1rem;
  }
}
</style>
